import { HttpClient } from '@angular/common/http';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';


@Component({
  selector: 'do-nothing',
  templateUrl: './do-nothing.component.html',
  standalone: false
})
export class DoNothingPMComponent implements OnInit, OnDestroy {
  @Input() isRLIndeferida: boolean = false;
 
  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

}
